import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "regles-pastilles-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('reglement.fournisseur.detail')) + " " + _toDisplayString(this.numeroReglement) + " ", 1),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_ReglePastille, { cle: "reglementsFournisseur.definition" }),
          _createVNode(_component_ReglePastille, { cle: "reglementFournisseurDetail.facturesLiees" })
        ])
      ])
    ]),
    _createVNode(_component_BorderedIconButton, {
      title: "RETOUR",
      imgUrl: _ctx.imgUrl,
      className: "back-btn",
      onClick: this.$router.back
    }, null, 8, ["imgUrl", "onClick"]),
    (this.reglements && this.isLoaded)
      ? (_openBlock(), _createBlock(_component_DataList, {
          key: 0,
          data: this.reglements,
          "stop-propa-on-pdf": true,
          onSelect: _ctx.goToPage
        }, null, 8, ["data", "onSelect"]))
      : _createCommentVNode("", true),
    (_ctx.isAttachmentLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}